import { useState, useEffect } from "react";
import { Box, Text, Image, Spinner } from "@chakra-ui/react";
import { Document, Page, pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

const FilePreview = ({ fileUrl }: { fileUrl: string }) => {
  const [fileType, setFileType] = useState<
    "image" | "pdf" | "unsupported" | null
  >(null);

  useEffect(() => {
    if (!fileUrl) {
      setFileType(null);
      return;
    }

    const urlWithoutParams = fileUrl.split("?")[0];
    const extensionMatch = urlWithoutParams.match(/\.([a-zA-Z0-9]+)$/);
    const extension = extensionMatch ? extensionMatch[1].toLowerCase() : "";

    setFileType("image");
    if (extension === "pdf") setFileType("pdf");
  }, [fileUrl]);

  if (!fileUrl || fileType === null) {
    return null;
  }

  if (fileType === "pdf") {
    return (
      <Box width="100%" height="100%" overflow="auto">
        <Document
          file={fileUrl}
          loading={
            <Box
              width="100%"
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Spinner size="lg" />
              <Text color="gray.500" ml={2}>
                Carregando documento...
              </Text>
            </Box>
          }
          error={
            <Box
              width="100%"
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Text color="gray.500">Não foi possível carregar o PDF.</Text>
            </Box>
          }
        >
          <Page
            pageNumber={1}
            width={300}
            renderAnnotationLayer={false}
            renderTextLayer={false}
          />
        </Document>
      </Box>
    );
  }

  return (
    <Image
      src={fileUrl}
      alt="Preview do Documento"
      objectFit="contain"
      width="100%"
      height="100%"
      fallback={
        <Box
          width="100%"
          height="100%"
          bg="gray.100"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Text color="gray.500">Imagem não disponível</Text>
        </Box>
      }
    />
  );
};

export default FilePreview;
